import { useNavigate } from 'react-router';
import { LinkComponent } from 'forstok-ui-lib';
import type { LinkMode, TMouseEvent } from 'forstok-ui-lib';
import { removeCookieEverywhere } from '../../../utils/cookies';
import { client } from '../../../utils/forstok';
import Auth from './auth/auth';

export const destroyUser = async (callback?: () => void) => {
  await client.clearStore();
  removeCookieEverywhere('token');
  removeCookieEverywhere('permission');
  removeCookieEverywhere('password');
  removeCookieEverywhere('users');
  removeCookieEverywhere('warehouse');
  removeCookieEverywhere('otpEmail');
  window.sessionStorage.clear();
  window.localStorage.clear();
  callback && callback();
};

export const expiredUser = () => {
  return destroyUser(() => {
    window.location.href = '/users/login?k=exp';
  });
};

const Logout = ({ mode }:{ mode?: LinkMode }) => {
  const navigate = useNavigate();

  const handleClick: TMouseEvent = e => {
    e.preventDefault();
    void destroyUser(() => {
      Auth.logout(() => void navigate('/users/login'));
    });
  };

  return (
    <LinkComponent mode={mode || 'clearR'} onClick={handleClick}>Logout</LinkComponent >
  );
};

export default Logout;
